import { render, staticRenderFns } from "./IotModelPointsList.vue?vue&type=template&id=61875b87&scoped=true&"
import script from "./IotModelPointsList.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsList.vue?vue&type=script&lang=js&"
import style0 from "./IotModelPointsList.vue?vue&type=style&index=0&id=61875b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61875b87",
  null
  
)

export default component.exports